import i18n from "../../i18n";
import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { OFFLINE_QUICK_ACTIONS } from "@/lib/offlineQuickActions";

export default function EmployeeAddSheetPage() {
    const nav = useNavigate();

    return (
        <Sheet open onOpenChange={(open) => !open && nav("/field", { replace: true })}>
            <SheetContent side="bottom" className="h-[85vh] rounded-t-3xl border-t border-border p-5 sm:max-w-none">
                <SheetHeader className="text-left">
                    <SheetTitle>{i18n.t("batch4.c40810f5c31d")}</SheetTitle>
                    <SheetDescription>{i18n.t("batch4.6af2ef649a46")}</SheetDescription>
                </SheetHeader>
                <div className="mt-5 grid grid-cols-1 gap-3">
                    {OFFLINE_QUICK_ACTIONS.map((item) => (
                        <Button
                            key={item.label}
                            variant="outline"
                            className="h-12 justify-start opacity-80"
                            onClick={() => nav(item.to, { replace: true })}
                            data-testid={`employee-add-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
                        >
                            {item.label}
                        </Button>
                    ))}
                </div>
            </SheetContent>
        </Sheet>
    );
}
